import React, { useEffect, useState, useMemo, useContext } from "react"
import Header from "../../../../../layouts/Header"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { PickingContextProvider } from "../../../PickingContext"
import VerProductosPickingComponent from "../../../components/VerProductosPickingComponent"

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const VerProductosPicking = () => {
  return (
    <PickingContextProvider>
      <ThemeProvider theme={theme}>
        <Header />
        <VerProductosPickingComponent />
      </ThemeProvider>
    </PickingContextProvider>
  )
}

export default VerProductosPicking
